// extracted by mini-css-extract-plugin
export default {"win":"EventScore_win__evB-K","loss":"EventScore_loss__4qZk0","tie":"EventScore_tie__t95GP","live":"EventScore_live__17IEL"};